import React from 'react';
import Icon from '../../../components/AppIcon';

const ThreatAlert = ({ alerts, onDismiss }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'critical': return 'bg-error border-error';
      case 'high': return 'bg-warning border-warning';
      case 'moderate': return 'bg-info border-info';
      default: return 'bg-muted border-muted';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'critical': return 'AlertOctagon';
      case 'high': return 'AlertTriangle';
      case 'moderate': return 'Info';
      default: return 'Bell';
    }
  };

  if (!alerts || alerts?.length === 0) return null;

  return (
    <div className="absolute top-4 left-4 w-96 max-w-full space-y-2 z-[400]">
      {alerts?.map((alert) => (
        <div
          key={alert?.id}
          className={`${getSeverityColor(alert?.severity)} bg-opacity-95 border-l-4 rounded-lg p-4 shadow-conservation-lg animation-organic`}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-start gap-3 flex-1">
              <Icon 
                name={getSeverityIcon(alert?.severity)} 
                size={24} 
                color={alert?.severity === 'critical' ? '#ffffff' : alert?.severity === 'high' ? '#000000' : '#ffffff'} 
              />
              <div className="flex-1">
                <h4 className={`font-semibold mb-1 ${alert?.severity === 'high' ? 'text-black' : 'text-white'}`}>
                  {alert?.title}
                </h4>
                <p className={`text-sm mb-2 ${alert?.severity === 'high' ? 'text-black/80' : 'text-white/90'}`}>
                  {alert?.description}
                </p>
                <div className="flex items-center gap-4 text-xs">
                  <span className={`flex items-center gap-1 ${alert?.severity === 'high' ? 'text-black/70' : 'text-white/80'}`}>
                    <Icon name="MapPin" size={12} />
                    {alert?.location}
                  </span>
                  <span className={`flex items-center gap-1 ${alert?.severity === 'high' ? 'text-black/70' : 'text-white/80'}`}>
                    <Icon name="Clock" size={12} />
                    {alert?.time}
                  </span>
                </div>
              </div>
            </div>
            <button
              onClick={() => onDismiss(alert?.id)}
              className={`flex-shrink-0 hover:opacity-70 transition-opacity ${alert?.severity === 'high' ? 'text-black' : 'text-white'}`}
              aria-label="Dismiss alert"
            >
              <Icon name="X" size={18} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ThreatAlert;